import React from 'react';

export const PropertyDetailError = ({
  error,
  title,
}: {
  error: Error;
  title: string;
}) => {
  console.error(error?.message);

  return (
    <div className="m-12">
      <div
        className="mx-auto mt-10 w-full text-center"
        role="alert"
        aria-live="polite"
      >
        <p className="text-red-500 mb-4">
          An error occurred while loading the {title}.
        </p>
        <p className="text-gray-700">Please try again</p>
      </div>
    </div>
  );
};
